
export default {
  name: 'GridItemBase',
  values: {
    gridColumnStart: undefined,
    gridColumnEnd: undefined,
    gridRowStart: undefined,
    gridRowEnd: undefined,
    justifySelf: undefined,
    alignSelf: undefined,
  },
  meta: {
    extendable: false,
  },
}
